// src/components/admin/ProtectedRoute.jsx
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, isAdmin, loading } = useAuth();

  // Show loading spinner while checking auth state
  if (loading) {
    return (
      <div className="min-h-screen bg-bg-main flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-primary-200 border-t-primary-500 rounded-full animate-spin mx-auto mb-4"></div>
          <div className="text-text-secondary">Checking admin access...</div>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  // Show unauthorized message if authenticated but not admin
  if (!isAdmin) {
    return (
      <div className="min-h-screen bg-bg-main flex items-center justify-center">
        <div className="max-w-md w-full p-8 text-center">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6">
            <div className="text-red-600 text-lg font-semibold mb-2">
              Access Denied
            </div>
            <div className="text-red-700 mb-4">
              This account does not have admin privileges.
            </div>
            <div className="text-sm text-red-600">
              Please contact support if you believe this is an error.
            </div>
          </div>
        </div>
      </div>
    );
  }

  // User is authenticated and is admin - render protected content
  return children;
};

export default ProtectedRoute;